<div class="already-confirmed">
  <img src="assets/images/Confirmation.svg" style="width: 200px;">
  <h4 class="mt-4 mb-5">
    {{ Localization.EmailAddressAlreadyConfirmed | translate}}
  </h4>
  <button mdbBtn type="button" color="amber" mdbWavesEffect (click)="login()">
    {{ Localization.Login | translate}}
  </button>
</div>